
export const handleSlides = (combinationslides) => {
  try {
    // Validate input
    if (!combinationslides) {
      throw new Error("combinationslides is required");
    }
    
    if (!combinationslides.allSlides) {
      throw new Error("combinationslides.allSlides is required");
    }
    
    const { allSlides } = combinationslides;
    
    // Validate required fields
    if (!allSlides.assetId) {
      throw new Error("assetId is required");
    }
    
    if (!Array.isArray(allSlides.slideIds)) {
      throw new Error("slideIds must be an array");
    }
    
    if (!Array.isArray(allSlides.slidenums)) {
      throw new Error("slidenums must be an array");
    }
    
    if (!Array.isArray(allSlides.signedUrls)) {
      throw new Error("signedUrls must be an array");
    }
    
    return {
      assetId: allSlides.assetId,
      slideIds: allSlides.slideIds,
      slidenums: allSlides.slidenums,
      signedUrls: allSlides.signedUrls
    };
    
  } catch (error) {
    console.error("Error in handleSlides:", error.message);
    throw error;
  }
};


// Function to filter selectedSlide based on available modulesData
export const getFilteredSelectedSlide = (selectedSlide, modulesData) => {
  if (!selectedSlide || !modulesData || modulesData.length === 0) {
    return selectedSlide;
  }


  const slideIdToModuleMap = {};
  modulesData.forEach((mod) => {
    slideIdToModuleMap[mod.slideId] = mod;
  });

  // Filter using your preferred mapping approach
  const filteredSlides = selectedSlide.slideIds
    .map((slideId, index) => {
      const module = slideIdToModuleMap[slideId];
    
      
      if (!module) return null;

      const slideData = {
        slideId: slideId,
        slidenum: selectedSlide.slidenums?.[index] || `Slide ${index + 1}`,
        signedUrl: selectedSlide.signedUrls?.find((url) => url.pageId === slideId) || null
      };
      
      return slideData;
    })
    .filter(Boolean);

  // Reconstruct the selectedSlide structure with filtered data
  return {
    ...selectedSlide,
    slideIds: filteredSlides.map(slide => slide.slideId),
    slidenums: filteredSlides.map(slide => slide.slidenum),
    signedUrls: filteredSlides.map(slide => slide.signedUrl).filter(Boolean)
  };
};